/// <reference path="../appDashboard.ts" />

var dashboardRemuneration = function () {
    return {
        restrict : 'E',
        replace: false,
        scope: {
            promiseUserPopulated: '=',
        },
        controller : 'DashboardRemunerationBlockController as dashboardRemunerationBlockController',
        templateUrl : '/templates/array-remuneration.html',
    };
};

appDashboard.directive('dashboardRemuneration', [dashboardRemuneration]);

